module.exports = __webpack_public_path__ + "img/14-green.a4b90694.svg";